import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { ReactNode } from 'react';

import type { CoverLotData } from '@/components/CatalogBannerExperiment/components/HeaderImageCluster/types';

import {
    CoverLotImage,
    LARGE_IMAGE_SIZE,
    THUMB_IMAGE_SIZE,
} from '@/components/CatalogBannerExperiment/components/HeaderImageCluster/CoverLotImage';
import { useTrackItemCardClicked } from '@/utils/amplitude/analytics';

type Props = {
    coverLots: CoverLotData[];
    doneOverlay: ReactNode;
    trackItemCardClicked: ReturnType<typeof useTrackItemCardClicked>;
};

export const DesktopImageCluster = ({ coverLots, doneOverlay, trackItemCardClicked }: Props) => {
    const [primaryLot, ...thumbLots] = coverLots;
    const hasThumbColumn = thumbLots.length > 0;

    return (
        <div className="relative flex overflow-hidden rounded-md border border-border-secondary bg-background-primary">
            <div
                className={cn(
                    'flex h-[280px] w-[280px] flex-shrink-0 items-center justify-center',
                    hasThumbColumn && 'border-r border-border-secondary'
                )}
            >
                <CoverLotImage
                    alt={primaryLot.title}
                    catalogId={primaryLot.catalogId}
                    href={primaryLot.url}
                    imageSize={LARGE_IMAGE_SIZE}
                    itemId={primaryLot.itemId}
                    promoted={primaryLot.promoted}
                    src={primaryLot.image}
                    srcSet={`${primaryLot.imageHighDpi} 2x`}
                    trackItemCardClicked={trackItemCardClicked}
                />
            </div>
            {hasThumbColumn && (
                <div className="flex flex-col">
                    {thumbLots.map((lot, index) => (
                        <div
                            key={lot.itemId}
                            className={cn(
                                'flex h-3xl w-3xl items-center justify-center',
                                index < thumbLots.length - 1 && 'border-b border-border-secondary'
                            )}
                        >
                            <CoverLotImage
                                alt={lot.title}
                                catalogId={lot.catalogId}
                                href={lot.url}
                                imageSize={THUMB_IMAGE_SIZE}
                                itemId={lot.itemId}
                                promoted={lot.promoted}
                                src={lot.image}
                                srcSet={`${lot.imageHighDpi} 2x`}
                                trackItemCardClicked={trackItemCardClicked}
                            />
                        </div>
                    ))}
                </div>
            )}
            {doneOverlay}
        </div>
    );
};
